import type { VersionModel } from "./specsModel/VersionModel";

export type SpecsImageSourceOption = {
  label: string;
  imageUrl: string;
};

function addUniqueSourceOption(
  options: SpecsImageSourceOption[],
  option: SpecsImageSourceOption
) {
  if (
    !option.imageUrl ||
    options.some((item) => item.imageUrl === option.imageUrl)
  ) {
    return;
  }
  options.push(option);
}

export function buildModelImageSourceOptions(
  version: VersionModel | null | undefined,
  sideName: string
): SpecsImageSourceOption[] {
  if (!version) {
    return [];
  }

  const options: SpecsImageSourceOption[] = [];
  const globalSide = version.generatorSides?.find(
    (side) => side.name === sideName
  );
  addUniqueSourceOption(options, {
    label: `Global highlight ${sideName}`,
    imageUrl: globalSide?.highlightUrl ?? "",
  });

  const bodyPart = version.getPart("body");
  bodyPart?.elements.forEach((element) => {
    element.styles.forEach((style) => {
      style.layers.forEach((layer) => {
        const layerSide = layer.sides.find((side) => side.name === sideName);
        addUniqueSourceOption(options, {
          label: `Body highlight - ${layer.layerLabel || layer.name}`,
          imageUrl: layerSide?.highlightUrl ?? "",
        });
      });
    });
  });

  return options;
}
